module.exports = __webpack_public_path__ + "static/git-d999f974556c397c05d051b3f42c26be.png";